import { watchOnce } from '@vueuse/core';
import { reactive } from 'vue';

import { isFeatureToggleActive } from '../customFeatureToggles';

export type StatsigExperimentName =
  | 'hotel_details_room_cards_grid_layout'
  | 'calendar_without_prices_in_car_trip'
  | 'new_book_type_button'
  | 'to_meta_hotel_card'
  | 'low_price_calendar_button'
  | 'carousel_last_card_copy_update'
  | 'see_all_hotel_button';

interface StatsigExperimentState {
  value: boolean;
  isLoaded: boolean;
}

type StatsigExperiments = Record<StatsigExperimentName, StatsigExperimentState>;

const statsigExperiments = reactive<StatsigExperiments>({
  hotel_details_room_cards_grid_layout: { value: false, isLoaded: false },
  calendar_without_prices_in_car_trip: { value: false, isLoaded: false },
  new_book_type_button: { value: false, isLoaded: false },
  to_meta_hotel_card: { value: false, isLoaded: false },
  low_price_calendar_button: { value: false, isLoaded: false },
  carousel_last_card_copy_update: {
    value: false,
    isLoaded: false,
  },
  see_all_hotel_button: { value: false, isLoaded: false },
});

export function assignExperimentValue(
  experimentName: StatsigExperimentName,
  value: boolean
): void {
  statsigExperiments[experimentName].value = value;
  statsigExperiments[experimentName].isLoaded = true;
}

export async function isExperimentAsync(
  experimentName: StatsigExperimentName
): Promise<boolean> {
  return new Promise((resolve) => {
    if (isFeatureToggleActive(experimentName)) {
      resolve(true);
    } else if (isFeatureToggleActive(`!${experimentName}`)) {
      resolve(false);
    } else if (statsigExperiments[experimentName].isLoaded) {
      resolve(statsigExperiments[experimentName].value);
    } else {
      watchOnce(
        () => statsigExperiments[experimentName].isLoaded,
        async () => resolve(statsigExperiments[experimentName].value)
      );
    }
  });
}
